import BrandModal from './BrandModal';
export default BrandModal;
